/** @format */

export const git = [
  {
    title: 'Модуль 1',
    path: '/git/1',
    items: [
      { title: 'Введение', path: '/git/1/1' },
      { title: 'Секции Git-проекта', path: '/git/1/2' },
      { title: 'Состояния Git', path: '/git/1/3' },
      { title: 'Основы Git', path: '/git/1/4' },
      { title: 'Процесс работы с Git-проектом', path: '/git/1/5' },
      { title: 'Работа с Git из консоли', path: '/git/1/6' },
      { title: 'Файл .gitignore', path: '/git/1/7' },
    ],
  },
]
